import axios from "../../plugins/axios";
import authHeader from "./authHeader";

export default {
	getReportTypes,
}
function getReportTypes() {
	return axios.get('/report-types' ,authHeader.classicalHeader())
}
